module.exports = __webpack_public_path__ + "img/public/SiteIcons/modelIcon.svg?940e3a1b";